import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "dayjs/locale/ja";
import React, { ReactNode } from "react";
import "../../../../stylesheets/public.css";
import "../../../shared/lib/init";
import theme from "./theme";
import "cropperjs/dist/cropper.css";

import "@fontsource/ibm-plex-sans-jp/400.css";
import "@fontsource/ibm-plex-sans-jp/500.css";
import "@fontsource/ibm-plex-sans-jp/600.css";
import "@fontsource/ibm-plex-sans-jp/700.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "yakuhanjp/dist/css/yakuhanjp_s.css"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export default function renderWithLayout<T>(Component: React.ComponentType<T>) {
  return function InnerComponent(
    props: T & React.JSX.IntrinsicAttributes,
  ): ReactNode {
    return (
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <Component {...props} />
        </QueryClientProvider>
      </ChakraProvider>
    );
  };
}
